import { Component, ElementRef, ViewChild } from '@angular/core';
import AOS from 'aos';
import 'aos/dist/aos.css';
import { SharedModule } from '../../shared/shared.module';
import { TranslatePipe } from '@ngx-translate/core';
import { ContactUsFormComponent } from '../../shared/Components/contact-us-form/contact-us-form.component';
import { AboutUsComponent } from '../about-us/about-us.component';
import {
  FormBuilder,
  Validators,
  FormGroup,
  FormControl,
} from '@angular/forms';
import { ApiService } from '../../services/api.service';
import { SuccessModalComponent } from '../../shared/Components/success-modal/success-modal.component';
import { debounceTime, distinctUntilChanged } from 'rxjs';

@Component({
  selector: 'app-home',
  imports: [SharedModule, ContactUsFormComponent, SuccessModalComponent],
  templateUrl: './home.component.html',
  styleUrl: './home.component.css',
})
export class HomeComponent {
  @ViewChild('heroVideo') video!: ElementRef<HTMLVideoElement>;

  constructor(private fb: FormBuilder, private apiService: ApiService) {
    this.contactForm = this.fb.group({
      senderEmail: [
        '',
        [
          Validators.required,
          Validators.email,
          Validators.pattern(
            '^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\\.[a-zA-Z]{2,}$'
          ),
        ],
      ],
      senderFirstName: [
        'mahmoud',
        [Validators.required, Validators.pattern(/^[A-Za-z]+(?: [A-Za-z]+)*$/)],
      ],
      senderLastName: [
        'mueslm',
        [Validators.required, Validators.pattern(/^[A-Za-z]+(?: [A-Za-z]+)*$/)],
      ],
      emailBody: ['i need a new project', [Validators.required]],
    });
  }

  ngOnInit() {
    AOS.init();

    this.contactForm
      .get('senderEmail')
      ?.valueChanges.pipe(debounceTime(500))
      .subscribe((value) => {
        this.isTypingFinished = !!(value && value.length > 0);
      });
  }

  ngAfterViewInit() {
    const videoElement = this.video.nativeElement;

    videoElement.muted = true;

    videoElement.load();

    videoElement.play().catch((error) => {});
  }

  contactForm: FormGroup;
  isSubmitted = false;
  showSuccessModal = false;
  isTypingFinished = false;

  getContactControl(controlName: string): FormControl | null {
    return this.contactForm.get(controlName) as FormControl;
  }

  onSubmit() {
    this.isSubmitted = true;
    this.contactForm.markAllAsTouched();

    if (this.contactForm.invalid) {
      return;
    }

    const formValue = this.contactForm.value;
    const payload = {
      senderEmail: formValue.senderEmail,
      senderFirstName: formValue.senderFirstName,
      senderLastName: formValue.senderLastName,
      emailBody: formValue.emailBody,
    };

    this.apiService.contactUs(payload).subscribe({
      next: (response) => {
        this.contactForm.reset({
          senderEmail: '',
          senderFirstName: 'mahmoud',
          senderLastName: 'mueslm',
          emailBody: 'i need a new project',
        });
        this.isSubmitted = false;
        this.showSuccessModal = true;
        this.isTypingFinished = false;
      },
      error: (err) => {
        console.error('API Error:', err);
      },
    });
  }
}
